module.exports = __webpack_public_path__ + "img/signup-IMG.d77570e2.png";